import { Box, MenuItem, Typography } from "@mui/material";
import { Select } from "app/components/Select";
import { DropdownIcon } from "app/icons";
import React from "react";

import { useStyles } from "../styles";
import { ProfileSelectProps } from "../types";

const ProfileSelect = ({ label, value, options }: ProfileSelectProps) => {
  const styles = useStyles();

  return (
    <Box className={styles.formField}>
      <Typography className={styles.fieldLabel}>{label}</Typography>
      <Select
        fullWidth
        value={value}
        noDefaults
        placeholder=""
        className={`${styles.textField} ${styles.preferencesSelect}`}
        SelectProps={{
          IconComponent: DropdownIcon,
        }}
        menuItems={options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      />
    </Box>
  );
};

export default ProfileSelect;
